<script>
    import PositiveControlModel from "./Models/positiveControlModel";
    import Loader from './Components/Loader.svelte';
    import {addFormModal} from './Forms/ModalFormManager.svelte';
    import {notifier} from '@beyonk/svelte-notifications';
    import {confirm} from './Components/Confirmation.svelte';
    import SortableTable from './Components/SortableTable.svelte';
    import {forms} from './lib/forms';
    import {tables} from './lib/tables';

    let controlsList = PositiveControlModel.getPositiveControlList();

    let importing;


    function addControl() {
        addFormModal({
            fields: forms['positiveControl']
        }).then(formData => {
            PositiveControlModel.createPositiveControl(formData).then(() => notifier.success("Control Added"));
        }).catch(() => null);
    }

    function editControl(control) {
        addFormModal({
            fields: forms['positiveControl'],
            data: control
        }).then(formData => {
            PositiveControlModel.savePositiveControl(formData).then(() => notifier.success("Control Saved"));
        }).catch(() => null)
    }

    function deleteControl(control) {
        confirm("Are you sure you want to delete this control?").then(() => {
            PositiveControlModel.deletePositiveControl(control).then(() => {
                notifier.success("Control Deleted");
            });
        }).catch(() => null)
    }

    let sortFields = tables['positiveControls'];
</script>

<Loader loading={!$controlsList}>
    <div class="container is-fluid">
        <h1 class="title is-1">Positive Controls</h1>
        <SortableTable {sortFields} tableData={$controlsList} tableClass="NISTTable">
            <div slot="filterActions"><button class="button is-success" on:click={addControl}>Add Positive Control</button></div>
            <div slot="rowActions" let:row={control}>
                <div class="buttons is-centered">
                    <button class="button is-danger" on:click={() => deleteControl(control)}>Delete</button>
                    <button class="button is-link" on:click={() => editControl(control)}>Edit</button>
                </div>
            </div>
        </SortableTable>
    </div>
</Loader>

{#if importing}
    <div class="importLoader">
        <Loader></Loader>
    </div>
{/if}

<style>
    .container {
        padding-left: 32px;
        padding-right: 32px;
    }

    :global(.NISTTable td.control) {
        white-space: pre-wrap;
    }

    :global(.NISTTable .function) {
        color: white;
        font-weight: bold;
    }

    :global(.NISTTable td[data-field="Identify"]) {
        background-color: #47a6dc !important;
    }

    :global(.NISTTable td[data-field="Protect"]) {
        background-color: #845295 !important;
    }

    :global(.NISTTable td[data-field="Detect"]) {
        background-color: #f99e1b !important;
    }

    :global(.NISTTable td[data-field="Respond"]) {
        background-color: #ec3945 !important;
    }

    :global(.NISTTable td[data-field="Recover"]) {
        background-color: #39b54a !important;
    }

    :global(.NISTTable td.risk) {
        font-weight: bold;
    }

    :global(.NISTTable td.risk[data-field="High"]) {
        color: red;
    }

    :global(.NISTTable td.risk[data-field="Medium"]) {
        color: orange;
    }

    :global(.NISTTable td.risk[data-field="Low"]) {
        color: green;
    }
</style>